import { useState, useEffect } from 'react';

function matchMediaAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function';
}

/**
 * Returns true when the viewport matches the given media query.
 * Example: useMediaQuery('(min-width: 768px)')
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (!matchMediaAvailable()) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (!matchMediaAvailable()) return;
    const media = window.matchMedia(query);
    setMatches(media.matches);
    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, [query]);

  return matches;
}
